module.exports = __webpack_public_path__ + "img/icon-jjptadmin-logo.84a5f929.png";